// extracted by mini-css-extract-plugin
module.exports = {"loader":"styles_loader__3Qxzb","cardHeader":"styles_cardHeader__1cD7f","buttons":"styles_buttons__3XdX0"};